<template>
  <transition :duration="{ enter: 0, leave: 8000 }">
    <div
      v-show="open"
      class="grid-status-wrapper"
    >
      <slot />
    </div>
  </transition>
</template>

<script>
export default {
  name: 'TransitionWrapper',
  props: {
    name: String,
    value: { type: Boolean, required: true, default: true },
  },
  data() {
    return {
      isAnimationDisabled: true,
    };
  },
  computed: {
    open: {
      get() {
        return !!this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  watch: {
    value(newVal, oldVal) {
      if (oldVal === undefined) {
        localStorage.setItem(`top-dashboard-visible-${this.name}`, true);
      } else if (newVal !== oldVal) localStorage.setItem(`top-dashboard-visible-${this.name}`, newVal);
    },
  },
  created() {
    const open = localStorage.getItem(`top-dashboard-visible-${this.name}`);
    this.open = open === 'true' || open === null;
    setTimeout(() => {
      this.isAnimationDisabled = false;
    }, 1000);
  },
};
</script>

<style lang="scss" scoped>
.grid-status-wrapper {
  max-width: 100%;
  position: relative;
  background-color: $-system-app-background;
}
.v-enter-active,
.v-leave-active {
  transition: all 0.3s linear;
  transform: translateY(0px);
  height: 216px;
}

.v-enter-from {
  height: 216px;
  transform: translateY(-216px);
}
.v-leave-to {
  height: 0px;
  opacity: 0;
  transform: translateY(-216px);
}

.close-button-wrapper {
  position: absolute;
  top: 8px;
  right: 8px;
  & .icon-x-class {
    width: 32px;
    height: 32px;
  }
}
</style>
